import styles from './index.scss'
import xialaIco from './xiala_ico.png'
import { Button } from 'antd-mobile'
import { forwardRef, Ref, useState } from 'react'
import iconUnSelected from './buxuanzhong.png'

type DisabledDiscountCouponCardPropsType = {
  onSelect?: () => void
  onConfirm?: () => void
  data: {
    expirationStart: string // 有效期开始
    expirationEnd: string // 有效期结束
    instructions: string // 使用说明
    couponType: 'discount' | 'reduce' // 优惠卷类型：折扣 discount  满减 reduce
    couBarriersAmount: number // 使用门槛
    cuoName: string //优惠券名称
    cuoMaxAmount: number // 最多优惠金额
    cuoDiscount: number // 折扣
    status: number // 状态
  }
  containerStyles?: React.CSSProperties
}

const icons: any = {
  '1': require('./used-bg.png'),
  '3': require('./disabled-bg.png'),
  '4': require('./disabled-bg.png'),
}

// 失效、已使用效果的优惠券
export default function DisabledDiscountCouponCard(
  props: DisabledDiscountCouponCardPropsType,
) {
  const { data } = props
  const {
    expirationStart,
    expirationEnd,
    instructions,
    couponType,
    couBarriersAmount,
    cuoName,
    cuoMaxAmount,
    cuoDiscount,
    status,
  } = data

  const [open, setOpen] = useState<any>(false)
  const DiscountsComponents: any = {
    discount: (
      <div className={styles.discounts}>
        <div className={styles.num}>
          {cuoDiscount}
          <span>折</span>
        </div>
        <div className={styles.condition}>满{couBarriersAmount}折</div>
      </div>
    ),
    reduce: (
      <div className={styles.discounts}>
        <div className={styles.num}>
          {cuoDiscount}
          <span>元</span>
        </div>
        <div className={styles.condition}>满{Number(couBarriersAmount)}减</div>
      </div>
    ),
    quota: (
      <div className={styles.discounts}>
        <div className={styles.num}>
          {cuoDiscount}
          <span>元</span>
        </div>
        <div className={styles.condition}>定额</div>
      </div>
    ),
  }

  return (
    <div
      className={styles.disabledDiscountCouponCard}
      style={{
        background: `url('${icons[status]}') no-repeat, #fff`,
        backgroundSize: '60px 66px',
        backgroundPosition: 'right bottom',
      }}
    >
      <div className={styles.upperPart}>
        {DiscountsComponents[couponType]}
        <div className={styles.info}>
          <div className={styles.name}>{cuoName}</div>
          <div className={styles.date}>
            {expirationStart} 至 {expirationEnd}
          </div>
        </div>
      </div>
      <div className={styles.nextPart}>
        <div className={styles.explainTitle} onClick={() => setOpen(!open)}>
          使用说明
          <img
            src={xialaIco}
            className={`${styles.icon} ${open ? styles.open : ''}`}
          />
        </div>
      </div>
      <div
        className={styles.explainContent}
        style={{ display: open ? 'block' : 'none' }}
      >
        {!!cuoMaxAmount && couponType === 'discount' && (
          <>
            最高可优惠{cuoMaxAmount}元<br />
          </>
        )}
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: instructions }}
        ></div>
      </div>
    </div>
  )
}

type SelectDisabledDiscountCouponCardPropsType = {
  data: {
    expirationStart: string // 有效期开始
    expirationEnd: string // 有效期结束
    instructions: string // 使用说明
    couponType: 'discount' | 'reduce' // 优惠卷类型：折扣 discount  满减 reduce
    couBarriersAmount: number // 使用门槛
    cuoName: string //优惠券名称
    cuoMaxAmount: number // 最多优惠金额
    cuoDiscount: number // 折扣
    status: number // 状态
    disableRemark: string // 不可用原因
  },
  containerStyles?: React.CSSProperties
}

// 不可用的优惠券
export const SelectDisabledDiscountCouponCard = forwardRef<HTMLDivElement, SelectDisabledDiscountCouponCardPropsType>(function (
  props: SelectDisabledDiscountCouponCardPropsType,
  ref: Ref<HTMLDivElement>,
) {
  const { data } = props
  const {
    expirationStart,
    expirationEnd,
    couponType,
    couBarriersAmount,
    cuoName,
    cuoMaxAmount,
    cuoDiscount,
    disableRemark,
  } = data

  const DiscountsComponents: any = {
    discount: (
      <div className={styles.discounts}>
        <div className={styles.num}>
          {cuoDiscount}
          <span>折</span>
        </div>
        <div className={styles.condition}>满{couBarriersAmount}折</div>
      </div>
    ),
    reduce: (
      <div className={styles.discounts}>
        <div className={styles.num}>
          {cuoDiscount}
          <span>元</span>
        </div>
        <div className={styles.condition}>满{Number(couBarriersAmount)}减</div>
      </div>
    ),
    quota: (
      <div className={styles.discounts}>
        <div className={styles.num}>
          {cuoDiscount}
          <span>元</span>
        </div>
        <div className={styles.condition}>定额</div>
      </div>
    ),
  }

  return (
    <div ref={ref} className={styles.disabledDiscountCouponCard} style={props?.containerStyles}>
      <div className={styles.upperPart}>
        {DiscountsComponents[couponType]}
        <div className={styles.info}>
          <div className={styles.name}>{cuoName}</div>
          <div className={styles.date}>
            {expirationStart} 至 {expirationEnd}
          </div>
        </div>
        <img src={iconUnSelected} className={styles.icon} />
      </div>
      <div className={styles.nextPart}>
        <div className={styles.rTitle}>不可用原因</div>
      </div>
      <div className={styles.reason}>{disableRemark}</div>
    </div>
  )
})
